export function removeLettersAndSpecialCharacters(value: string) {
  return value.replace(/[a-zA-Z!@#$%^&*;,'"\][=]/g, '');
}

export function onlyNumber(value: string) {
  return value.replace(/\D/g, '');
}
